import Icon from './Icons';

function friendlyError(msg) {
  const s = String(msg || '');
  if (!s || s === 'null' || s === 'undefined') return 'An unexpected error occurred.';
  if (
    s.includes('Load failed') ||
    s.includes('Failed to fetch') ||
    s.includes('FetchEvent') ||
    s.includes('NetworkError') ||
    s.toLowerCase().includes('network')
  ) {
    return "Can't reach the server. Check that the app is running and you're on the right network, then try again.";
  }
  if (s.includes('401') || s.toLowerCase().includes('unauthorized')) {
    return 'Your session has expired. Try signing in again.';
  }
  return s;
}

function WiltedPlantIcon({ size = 72, className = '', style = {} }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      style={{ display: 'block', ...style }}
      aria-hidden="true"
    >
      <path d="M408 32C474.3 32 528 85.7 528 152L528 158.2C557.3 170.4 576 199.5 576 235.1C576 263 550.7 309.9 510 346.8C506.2 350.3 501.2 352.1 496 352.1C490.8 352.1 485.8 350.3 482 346.8C441.3 310 416 263.1 416 235.1C416 199.5 434.7 170.4 464 158.2L464 152C464 121.1 438.9 96 408 96C377.1 96 352 121.1 352 152L352 576C352 593.7 337.7 608 320 608C302.3 608 288 593.7 288 576L288 280C288 249.1 262.9 224 232 224C201.1 224 176 249.1 176 280L176 318.2C205.3 330.4 224 359.5 224 395.1C224 423 198.7 469.9 158 506.8C154.2 510.3 149.2 512.1 144 512.1C138.8 512.1 133.8 510.3 130 506.8C89.3 469.9 64 423 64 395.1C64 359.4 82.7 330.4 112 318.2L112 280C112 213.7 165.7 160 232 160C252.2 160 271.3 165 288 173.8L288 152C288 85.7 341.7 32 408 32z" />
    </svg>
  );
}

export default function ErrorScreen({ message, onRetry, title = 'Something went wrong' }) {
  return (
    <div className="error-screen">
      <WiltedPlantIcon
        size={64}
        className="error-screen-plant"
      />
      <h2 className="error-screen-title">{title}</h2>
      <p className="error-screen-message">{friendlyError(message)}</p>
      {onRetry && (
        <button className="btn btn-secondary error-screen-retry" onClick={onRetry}>
          <Icon name="refreshCw" size={14} style={{ marginRight: 6 }} />
          Try again
        </button>
      )}
    </div>
  );
}
